import React, { useState } from "react"
import { Link } from "gatsby"
import ReactCookieConsent, { getCookieConsentValue } from "react-cookie-consent"

declare global {
  interface Window {
    dataLayer: unknown[]
  }
}

const CookieConsent: React.FC<unknown> = () => {
  const [hasDecided, setHasDecided] = useState(
    getCookieConsentValue() !== undefined
  )

  const accept = () => {
    setHasDecided(true)

    // See also gatsby-browser.js.
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "page_load_with_consent",
      path: window.location.pathname,
    })
  }

  const decline = () => {
    setHasDecided(true)
  }

  return (
    !hasDecided && (
      <div className="c-cookie-consent">
        <ReactCookieConsent
          hideOnAccept={false}
          onAccept={accept}
          onDecline={decline}
          enableDeclineButton={true}
          buttonText="Accept"
          declineButtonText="Refuse"
          disableStyles={true}
          containerClasses="c-cookie-consent--inner"
          contentClasses="c-cookie-consent--content"
          buttonWrapperClasses="c-cookie-consent--buttons"
          buttonClasses="c-cta -green -accept"
          declineButtonClasses="c-cta -outline -decline"
        >
          We use cookies to enhance your experience on this website and for
          advertisements. (read more{" "}
          <Link to="/articles/privacy-notice-company-representatives-northvolt/">
            here
          </Link>
          ).
        </ReactCookieConsent>
      </div>
    )
  )
}

export default CookieConsent
